import { InputFormValues } from '@/modules/CombinedLogs/types'
import { Input } from '@/ui/Input'
import { UseFormReturn } from 'react-hook-form'
import styles from './TableFormTripInput.module.scss'
import { TableFormRtnInput } from './TableFormRtnInput'
import { useEffect, useState } from 'react'
import { useCombinedLogsTableFormStateStore } from '@/modules/CombinedLogs/store'
import { useDebounce } from '@/helpers/useDebounce'
import clsx from 'clsx'

export const TableFormOriginalTripInput = ({ form }: { form: UseFormReturn<InputFormValues> }) => {
    const { setTrip, selectedOriginalTrips, setSelectedOriginalTrips } = useCombinedLogsTableFormStateStore()
    const [isTripFocused, setIsTripFocused] = useState(false)
    const [isRtnFocused, setIsRtnFocused] = useState(false)

    const trip = form.watch('originalTrip')
    const rtnTrips = form.watch('originalRtnTrips')
    const debouncedTrip = useDebounce(trip, 1000)

    useEffect(() => {
        // debounce the trip value
        if (debouncedTrip) {
            setTrip(debouncedTrip)
        }
    }, [debouncedTrip])

    useEffect(() => {
        // autofill Run, Duty, Fleet
        if (!isRtnFocused && trip && selectedOriginalTrips.length > 0) {
            // Run is the same for all trips
            form.setValue('originalRun', selectedOriginalTrips[0].run.toString())
            form.setValue(
                'originalDuty',
                selectedOriginalTrips
                    .map((trip) => {
                        if (trip.duty && trip.duty.length === 1) return trip.duty[0]
                    })
                    .join('/')
            )
            form.setValue('originalFleet', selectedOriginalTrips.map((trip) => trip.fleetNumber).join('/'))
        }
    }, [isRtnFocused])

    return (
        <>
            <div
                onClick={(e) => {
                    e.preventDefault()
                    setIsRtnFocused(true)
                }}
                className={clsx(styles.originalTripLabel, {
                    [styles.hidden]: isRtnFocused === true || !trip || !rtnTrips,
                })}
            >
                {trip}/{rtnTrips}
            </div>
            <div
                className={clsx(styles.tripInputContainer, {
                    [styles.hidden]: isRtnFocused === false && trip && rtnTrips,
                })}
            >
                <Input
                    {...form.register('originalTrip')}
                    className={styles.tripInput}
                    onFocus={() => setIsTripFocused(true)}
                    onBlur={() => setIsTripFocused(false)}
                    variant="table"
                    type="text"
                    maxLength={4}
                    transparent
                    fullWidth
                    placeholder={'Trip'}
                />
                <div className={clsx({ [styles.hidden]: !trip && !isTripFocused })}>
                    <TableFormRtnInput
                        name="originalRtnTrips"
                        control={form.control}
                        setFocused={setIsRtnFocused}
                        selectedTrips={selectedOriginalTrips}
                        setSelectedTrips={setSelectedOriginalTrips}
                        hidden={!trip}
                        trip={trip}
                    />
                </div>
            </div>
        </>
    )
}
